<dgx-modal
  [canCancel]="true"
  [submitButtonText]="'Core_YesProceed' | translate"
  [isSubmitDisabled]="false"
  [useDefaultForm]="true"
>
  <!-- Modal Body -->

  <ng-container class="modal-header"> </ng-container>
  <ng-container class="modal-body">
    <df-local-notification
      *ngIf="hasHostedContent"
      [type]="NotificationType.info"
      [text]="'Pathways_MoveWarningHostedContent' | translate"
      size="small"
      class="block guts-p-b-2"
    ></df-local-notification>
    <p>
      {{ 'Pathways_MoveConfirmationMessage' | translate }}
    </p>
    <p class="color-destructive">
      {{ 'Core_CannotBeUndone' | translate }}
    </p>
    <p>
      {{ 'Core_WouldYouLikeToProceed' | translate }}
    </p>
  </ng-container>
</dgx-modal>
